import { render, staticRenderFns } from "./Suku.vue?vue&type=template&id=09b4cec8"
import script from "./Suku.vue?vue&type=script&lang=js"
export * from "./Suku.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports